import { type TabsListVariant } from '~/components/component-library/Tabs/types'

export const TABS_LIST_CLASSNAME: Record<TabsListVariant, string> = {
  default: 'hidden items-center space-x-6 border-b border-default md:flex',
  table:
    'sticky left-0 hidden w-fit items-center space-x-6 pl-4 md:flex md:pl-6 lg:pl-8',
  dense: 'flex items-center gap-1 px-1',
}

// Full-width border the w-fit list can't draw itself
export const TABS_LIST_TABLE_FRAME_CLASSNAME = 'border-b border-muted pt-4'

// Dropdown shown in place of the row below md
export const TABS_LIST_DEFAULT_SELECT_FRAME_CLASSNAME = 'md:hidden'

export const TABS_LIST_TABLE_SELECT_FRAME_CLASSNAME =
  'sticky left-0 px-4 pb-3 md:hidden'

export const TABS_SELECT_TRIGGER_CLASSNAME =
  'group flex w-full select-none items-center justify-between gap-2 rounded-lg bg-surface-raised py-1.5 pl-3 pr-2 text-sm text-primary outline-none ring-1 ring-inset ring-default transition hover:bg-surface-hover focus-visible:ring-2 focus-visible:ring-focus data-[state=open]:ring-2 data-[state=open]:ring-focus'

export const TABS_SELECT_CONTENT_CLASSNAME =
  'anchored z-[99] flex w-[var(--radix-select-trigger-width)] flex-col gap-0.5 p-1 outline-none focus:outline-none data-[state=closed]:zoom-out-100 data-[state=open]:zoom-in-100'

export const TABS_SELECT_ITEM_CLASSNAME =
  'flex w-full cursor-pointer select-none items-center rounded-md px-2 py-1.5 text-sm text-primary outline-none transition-colors data-[disabled]:cursor-not-allowed data-[highlighted]:bg-surface-muted data-[state=checked]:bg-surface-muted data-[disabled]:opacity-50'

// Drawn as a sibling so an overflow-hidden trigger row can't clip it
export const TABS_LIST_DENSE_RULE_CLASSNAME = '-mt-px border-b border-default'

export const TABS_TRIGGER_BASE_CLASSNAME =
  'border-b-2 outline-none data-[state=active]:border-black data-[state=inactive]:border-transparent data-[state=inactive]:text-secondary data-[state=active]:dark:border-white'

const TABS_TRIGGER_STANDARD_CLASSNAME = '-mb-px px-1 pb-2 text-base font-medium'

export const TABS_TRIGGER_CLASSNAME: Record<TabsListVariant, string> = {
  default: TABS_TRIGGER_STANDARD_CLASSNAME,
  table: TABS_TRIGGER_STANDARD_CLASSNAME,
  dense: 'flex-shrink-0 px-2 py-1.5 text-sm font-normal',
}
